import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import {
    IGraphicInfo,
    IGraphicLineInfo,
    IGraphicProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/graphic-info/graphic-info.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { transaction } from '@src/slide/domain/slide-app';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { PathParser } from '@tencent/alloy-renderer';

export class GraphicProperty implements IGraphicProperty {
    private elementModelRef: IShapeModel | IPictureModel | IConnectorModel;

    public constructor(elementModel: IShapeModel | IPictureModel | IConnectorModel) {
        this.elementModelRef = elementModel;
    }

    public getGraphicInfo(): IGraphicInfo | null {
        if (this.elementModelRef.type === UIModelType.SHAPE
            || this.elementModelRef.type === UIModelType.IMAGE) {
            const model: IShapeModel | IPictureModel = this.elementModelRef as IShapeModel | IPictureModel;
            return {
                bgShape: model.props.style.bgShape,
                controlValues: model.props.style.controlValues,
            };
        }
        return null;
    }

    public updateGraphicInfo(graphicInfo: Partial<IGraphicInfo>): void {
        if (this.elementModelRef.type === UIModelType.SHAPE
            || this.elementModelRef.type === UIModelType.IMAGE) {
            transaction(() => {
                this.elementModelRef.updateProps({ style: graphicInfo });
                this.getBorderSketchManager()?.updatePathListWhenSizeChange(this.elementModelRef, graphicInfo);
            });
        }
    }

    public getGraphicLinInfo(): IGraphicLineInfo | null {
        if (this.elementModelRef.type === UIModelType.CONNECTOR) {
            const model: IConnectorModel = this.elementModelRef as IConnectorModel;
            return {
                bgLine: model.props.style.bgLine,
                controlValues: model.props.style.controlValues,
            };
        }
        return null;
    }

    public updateGraphicLineInfo(graphicLine: Partial<IGraphicLineInfo>): void {
        if (this.elementModelRef.type !== UIModelType.CONNECTOR) {
            return;
        }
        this.elementModelRef.updateProps({ style: graphicLine });
    }

    public isPathOpened(path: string): boolean {
        if (path.indexOf('Z') === -1 && path.indexOf('z') === -1) {
            const segments = PathParser.parse(path);
            const { length } = segments;
            // 判断该段path的首尾是否重合，若重合，即使不存在闭合指令，也认为这段path是闭合曲线
            if (length > 1 && segments[0].x === segments[length - 1].x && segments[0].y === segments[length - 1].y) {
                return false;
            }
            return true;
        }
        // 有闭合命令直接认为是封闭的
        return false;
    }

    private getBorderSketchManager() {
        const appServices = AppServiceProvider.getInstance().getAppServices() as IEditorAppServices;
        return appServices.editableServiceLayer?.borderSketchManager;
    }
}
